// Importujemy fetchWrapper, czyli naszego "uniwersalnego" helpera do zapytań HTTP (GET, POST itp.)
import { fetchWrapper } from "@/helpers/fetch-wrapper";

// Definiujemy klasę Tickets, która będzie obsługiwać pobieranie zgłoszeń (ticketów) z API 
class Tickets {

    async getTickets() {
        return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/tickets`);
    }

    async saveTicket(description, file, extra = {}) {
      // console.log('Zapisywanie zgłoszenia:', { description, file, extra });

      const userId = await this.getUserId();
      const {
        title = 'Zgłoszenie z systemu WIM',
        status = 'open',
        isOpen = true,
        handleBy = null,
        closedAt = null,
      } = extra;

      if (file) {
        const fd = new FormData();
        fd.append('userId', String(userId));
        fd.append('title', title);
        fd.append('description', description ?? '');
        fd.append('status', status);
        fd.append('isOpen', String(isOpen));
        if (handleBy !== null) fd.append('handleBy', String(handleBy));
        if (closedAt) fd.append('closedAt', closedAt);
        fd.append('attachment', file, file.name);
      
        return fetchWrapper.post(`${process.env.VUE_APP_API_URL}/tickets`, fd);
      }

      // bez pliku -> JSON
      const payload = { userId, title, description, status, isOpen, handleBy, closedAt };
      return fetchWrapper.post(`${process.env.VUE_APP_API_URL}/tickets`, payload);
    }

    async getUserId() {
        const response = await fetchWrapper.get(`${process.env.VUE_APP_API_URL}/users/self`);
        const data = response?.data ?? response;
        return data.id;
    }

    async getUserById(id) {
        const response = await fetchWrapper.get(`${process.env.VUE_APP_API_URL}/users/${id}`);
        const data = response?.data ?? response;
        return data;
    }

    async getUsersByOrganization() {
      const response = await fetchWrapper.get(`${process.env.VUE_APP_API_URL}/users`);
      const data = response?.data ?? response;
      return data;
    }

    async getTicketById(id) {
      const res = await fetchWrapper.get(`${process.env.VUE_APP_API_URL}/tickets/${id}`);
      return res?.data ?? res; // zwróć sam ticket
    }

    async updateTicket(id, payload) {
      return fetchWrapper.put(`${process.env.VUE_APP_API_URL}/tickets/${id}`, payload);
    }

    async getTicketImage(url) {
      return fetchWrapper.getBlob(url);
    }
}

// Eksportujemy instancję klasy Tickets (singleton)
export default new Tickets();
